<template>
  <div
    @click="handleClick(statusLocal === 'yes' ? 'no' : 'yes')"
    class="w-[50px] h-[30px] cursor-pointer bg-white border-gray-600 border-1 shadow border-solid rounded-full flex items-center justify-center"
  >
    <div
      :style="
        statusLocal === 'yes' ? 'background:#c1d2e2' : 'background:inherit'
      "
      class="relative w-[45px] h-[25px] bg-gray-200 rounded-full ease-linear transition-all duration-150"
    >
      <div
        class="absolute h-[25px] w-[25px] left:0 bg-white shadow rounded-full ease-linear transition-all duration-150"
        :style="statusLocal === 'yes' ? 'left:20px' : 'left:0'"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToggleBtn",
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    statusLocal: {
      get: function () {
        return this.status;
      },
      set: function (val) {
        this.$emit("update:status", val);
      }
    }
  },
  emits: ["update:status"],
  methods: {
    handleClick(status) {
      this.statusLocal = status;
    }
  }
};
</script>
